<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Manajemen User</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">User</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabmateri" data-toggle="tab">Daftar User</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tabmateri" class="tab-pane fade show active">
											<div class="card card-table">
												<div class="card-body p-3">
                                                    <div class="row text-center">
                                                        <div class="col-md-6">
                                                            
                                                            <input class="form-control" type="text" v-model="filter_email" 
                                                                placeholder="Silahkan masukan email user">

                                                        </div>
                                                    </div>
                                                    <div class="row text-center">
                                                        <div class="col-md-6">
                                                            
                                                            <input class="form-control" type="text" v-model="filter_nama" 
                                                                placeholder="Silahkan masukan nama user">
                                                                
                                                        </div>
                                                        <div class="col-md-3 ">
                                                            <button class="btn btn-primary btn-sm float-left" @click.prevent="getAll()"> Cari </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="card card-table mb-0">
												<div class="card-body">

                                                    <!-- <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" @click.prevent="goToBeliPaket()">Beli Paket</a>
                                                    </div> -->
                                                    <!-- <div class="row row-grid">
                                                    <virtual-list
                                                        class="list"
                                                        style="height: 360px; overflow-y: auto;"
                                                        :data-key="'id_user'"
                                                        :data-sources="lstuser"
                                                        :data-component="item"
                                                        :estimate-size="50"
                                                    />
                                                    </div> -->
                                                    <!-- :config="tableConfig"
                                                        :data="lstuser"
                                                        :height="800"
                                                        :itemHeight="55"
                                                        :minWidth="1000"
                                                        :selectable="true"
                                                        :enableExport="true"
                                                        v-on:changeSelection="handleSelectionChange"
                                                     -->
                                                    <!-- <vue-virtual-table
                                                        
                                                        :config="tableConfig"
                                                        :data="lstuser"
                                                        :height="tableAttribute.height"
                                                        :itemHeight="tableAttribute.itemHeight"
                                                        :minWidth="tableAttribute.minWidth"
                                                        :selectable="tableAttribute.selectable"
                                                        :enableExport="tableAttribute.enableExport"
                                                        :bordered="tableAttribute.bordered"
                                                        :hoverHighlight="tableAttribute.hoverHighlight"
                                                        :language="tableAttribute.language"
                                                        v-on:changeSelection="handleSelectionChange"
                                                        v-on:click="handleClickRow"
                                                        v-on:contextmenu="handleContextmenu"
                                                    >
                                                        <template slot-scope="scope" slot="actionCommon">
                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(scope.row)">
                                                            <i class="fas fa-edit"></i> Edit
                                                        </v-btn>      
                                                        &nbsp;
                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(scope.row)">
                                                            <i class="fas fa-times"></i> Delete
                                                        </v-btn>
                                                        </template>
                                                    </vue-virtual-table>
                                                     -->
													<div class="table-responsive">
                                                        <table id="tblUser" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-center">Nama User</th>
                                                                    <th class="">Email</th>
                                                                    <th class="text-ceter">No Hp</th>
                                                                    <th class="text-center">Status</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstuser" :key="ref.id_user">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.namauser }}</td>
                                                                    <td>{{ ref.email }}</td>
                                                                    <td>{{ ref.no_hp }}</td>
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.hak_akses == '1' , 'bg-info-light' : ref.hak_akses == '2', 'bg-danger-light' : ref.hak_akses == '3' }">{{ref.hak_akses_nm}}</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>      
                                                                        
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>                                                                  
                                                                    </td>
                                                                  
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>

												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
										
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        	
		<div id="addMdl" class="modal custom-modal fade" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Edit User</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">

						<!-- <div class="card card-table mb-0">
							<div class="card-body"> -->
								<!-- Tab Menu -->
								<nav class="user-tabs mb-4">
									<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
										<li class="nav-item">
											<a class="nav-link active" href="#akun" data-toggle="tab"><span class="med-records">Info Akun</span></a>
										</li>
										<li class="nav-item">
											<a class="nav-link" href="#paketaktif" data-toggle="tab">Paket Aktif</a>
										</li> 
										<li class="nav-item">
											<a class="nav-link" href="#riwayatpembelian" data-toggle="tab">Riwayat Pembelian</a>
										</li>
									</ul>
								</nav>
								<!-- /Tab Menu -->
								
								<!-- Tab Content -->
								<div class="tab-content pt-0">
											
									<!-- Course Records Tab -->
									<div id="akun" class="tab-pane fade show active">
										<form>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Nama Lengkap <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="text" v-model="user.namauser" required>
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>Email <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="text" v-model="user.email" required>
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>No Hp <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="text" v-model="user.no_hp" @input="acceptNumber" required>
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>Password Lama <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="text" v-model="user.password">
                                                    </div>

                                                    <div class="form-group">
                                                        <label>Password Baru <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="password" v-model="user.newpassword" required>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Role <span class="text-danger">*</span></label>
                                                        <v-select
                                                        :options="lstrole"
                                                        :reduce="lstrole => lstrole.id" 
                                                        label="text"
                                                        v-model="user.hak_akses"
                                                        />
                                                    </div>

                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Tanggal Lahir <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="date" v-model="user.birthday" required>
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>Gender <span class="text-danger">*</span></label>
                                                        <select class="form-control select" v-model="user.gender" required>
                                                            <option value="">Pilih Gender</option>
                                                            <option value="L">Laki-laki</option>
                                                            <option value="P">Perempuan</option>
                                                        </select>
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>Alamat <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="text" v-model="user.address" required>
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>Medsos <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="text" v-model="user.medsos" required>
                                                    </div>
                                                    
                                                    <div class="form-group">
                                                        <label>Kode Referral <span class="text-danger">*</span></label>
                                                        <input class="form-control" type="text" v-model="user.kode_referral" required>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </form>
									</div>

									
									<div id="paketaktif" class="tab-pane fade">
										<div class="table-responsive">
                                            <table id="tblPaketAktif" class="table table-hover table-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">#</th>
                                                        <th class="">Nama Paket</th>
                                                        <th class="text-ceter">Tanggal Pembelian</th>
                                                        <th class="text-ceter">Tanggal Pembayaran</th>
                                                        <th class="text-center">No Invoice</th>
                                                        <th class="text-center">Channel Pembayaran</th>
                                                        <!-- <th class="text-center">Status</th>
                                                        <th class="text-left">Action</th> -->
                                                    </tr>
                                                </thead>
                            
                                                <tbody>
                                                    <tr v-for="(ref, index) in lstpaketaktif" :key="ref.id_sales">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ ref.nama_paket }}</td>
                                                        <td>{{ ref.purchase_date }}</td>
                                                        <td >{{ ref.paid_at }}</td>
                                                        <td>{{ ref.external_id }}</td>
                                                        <td >{{ ref.payment_channel }}</td>
                                                        <!-- <td class="text-center">
                                                            <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.inv_status_nm == 'PENDING' , 'bg-success-light' : ref.inv_status == 'SETTLED', 'bg-danger-light' : ref.inv_status == 'EXPIRED' }">{{ref.inv_status_nm}}</span>
                                                        </td>
                                                        <td>
                                                            <template v-if="ref.inv_status != 'EXPIRED'">
                                                            <v-btn class="btn btn-sm bg-success-light" depressed small @click="goToInvoice(ref)">
                                                                Invoice
                                                            </v-btn>
                                                            </template>
                                                        </td>
                                                         -->
                                                    </tr>
                                                </tbody>                                            
                                            </table>
                                            
                                        </div>
									</div>
                                    
									<div id="riwayatpembelian" class="tab-pane fade">
										<div class="table-responsive">
                                            <table id="tblRiwayat" class="table table-hover table-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th class="text-left">#</th>
                                                        <th class="text-center">No Invoice</th>
                                                        <th class="">Nama Paket</th>
                                                        <th class="text-ceter">Tanggal Pembelian</th>
                                                        <th class="text-center">Batas Pembayaran</th>
                                                        <th class="text-center">Status</th>
                                                        <th class="text-left">Action</th>
                                                    </tr>
                                                </thead>
                            
                                                <tbody>
                                                    <tr v-for="(ref, index) in lsttransaksi" :key="ref.id_sales">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ ref.external_id }}</td>
                                                        <td>{{ ref.nama_paket }}</td>
                                                        <td>{{ ref.purchase_date }}</td>
                                                        <td >{{ ref.expired_date }}</td>
                                                        <td class="text-center">
                                                            <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.inv_status == 'PENDING' , 'bg-success-light' : ref.inv_status == 'PAID', 'bg-danger-light' : ref.inv_status == 'EXPIRED' }">{{ref.inv_status_nm}}</span>
                                                        </td>
                                                        <td>
                                                            <template v-if="ref.inv_status != 'EXPIRED'">
                                                            <v-btn class="btn btn-sm bg-success-light" depressed small @click="goToInvoice(ref)">
                                                                Invoice
                                                            </v-btn>
                                                            </template>
                                                        </td>
                                                        
                                                    </tr>
                                                </tbody>                                            
                                            </table>
                                            
                                        </div>
									</div>

								</div>	
							<!-- </div>
						</div> -->

					</div>
					<div class="modal-footer">
						<div class="submit-section text-center">
							<button class="btn btn-primary submit-btn" @click.prevent="save">Simpan</button>
						</div>
					</div>
				</div>
			</div>
		</div>

        
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus User</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus user <b>{{ user.namauser }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import $ from 'jquery';
import Item from './Item';
// import VueVirtualTable from 'vue-virtual-table';
// import moment from "moment";

export default {
    components: {
        Sidebar,
        // VueVirtualTable
    },
	name: 'Materi',
    data() {
        return {
            // tableConfig: [
            //     { prop: '_index', name: '#', width: 80 },
            //     {
            //     prop: 'namauser',
            //     name: 'User',
            //     searchable: true,
            //     sortable: true,
            //     justifyContent:'left'
            //     // summary: 'COUNT'
            //     },
            //     { prop: 'email', name: 'Email', searchable: true, sortable: true,justifyContent:'left'},
            //     { prop: 'no_hp', name: 'Phone', searchable: true,justifyContent:'left'/*filterable: true*/ },
            //     { prop: '_action', name: 'Action', actionName: 'actionCommon' }
            // ],
            // // tableData: [
            // //     { user: 'a1', age: 20, city: 'aaaa' },
            // //     { user: 'a2', age: 21, city: 'bbbb' },
            // //     { user: 'a3', age: 23, city: 'aaaa' }
            // // ],
            // tableAttribute: {
            //     height: 650,
            //     itemHeight: 62,
            //     minWidth: 1000,
            //     // selectable: true,
            //     enableExport: true,
            //     bordered: false,
            //     hoverHighlight: true,
            //     language: "en"
            // },
            item: Item,
            lstuser: [],
            lsttransaksi: [],
            lstpaketaktif:[],
            user: {
                id_user:'',
                email: '',
                username: '',
                namauser: '',
                hak_akses: '',
                password: '',
                no_hp: '',
                birthday: '',
                gender: '',
                address: '',
                medsos: '',
                password:'',
                newpassword: '',
                kode_referral: ''
            },
            
            lstrole: [
                {id: '1', text: 'Siswa'},
                {id: '2', text: 'Pengajar'},
                {id: '3', text: 'Admin'},
                {id: '4', text: 'Mitra'}
            ],
            filter_email:'', 
            filter_nama:'', 
           
        }
    },
    created: function () {
        // this.getAll();
    },  

    methods: {
		acceptNumber() {
			// console.log(this.noHp);
        	var x = this.user.no_hp.replace(/\D/g, '').match(/(\d{0,4})(\d{0,4})(\d{0,4})/);
			this.user.no_hp = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
		},

        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
                    dom: 'Bfrtip',
                    // buttons: ['copy', 'csv', 'excel', 'pdf', 'print'
                    // ]                    
                    buttons: [
                        { extend: 'copy', className: 'btn btn-sm btn-primary glyphicon glyphicon-duplicate' },
                        { extend: 'csv', className: 'btn btn-sm btn-primary glyphicon glyphicon-save-file' },
                        // { extend: 'excel', className: 'btn btn-sm btn-primary glyphicon glyphicon-list-alt' },
                        // { extend: 'pdf', className: 'btn btn-sm btn-primary glyphicon glyphicon-file' },
                        { extend: 'print', className: 'btn btn-sm btn-primary glyphicon glyphicon-print' }
                    ]

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        resetVar: function(ref,isDasabled=false){
            if(ref){                
                this.user.id_user = ref.id_user;
                this.user.email = ref.email;
                this.user.username = ref.email;
                this.user.namauser = ref.namauser;
                this.user.password = ref.password;
                this.user.newpassword = ref.newpassword;
                this.user.hak_akses = ref.hak_akses;
                this.user.no_hp = ref.no_hp;
                this.user.kode_referral = ref.kode_referral;
                this.user.birthday = ref.birthday;
                this.user.gender = ref.gender;
                this.user.address = ref.address;
                this.user.medsos = ref.medsos;
            } else {      
                this.user.id_user = '';
                this.user.email = '';
                this.user.username = '';
                this.user.namauser = '';
                this.user.password = '';
                this.user.newpassword = '';
                this.user.hak_akses = '';
                this.user.birthday = '';
                this.user.gender = '';
                this.user.address = '';
                this.user.medsos = '';
            }
            
            $("#frm input").prop("disabled", isDasabled);
            $("#frm v-select").prop("disabled", isDasabled);
        },


        
        getEdit: function (ref) {
            this.resetVar(ref);
            this.getPaketAktif(ref);
            this.getRiwayatPembelian(ref);
            $("#addMdl").modal('show');
        },

        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },

        //--------------------------
        // Get Materi
        getAll: function () {
            // axios.get('api/lstuser').
            axios.post('api/userbyemailname', {
                    email: this.filter_email,
                    nama: this.filter_nama,
                })
                .then(res => {
                    
                    this.clearTbl("tblUser");
                    this.lstuser = res.data.data;
                    this.initDt("tblUser");
                    // console.log(res.data);
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        
        save: function () {
            axios.post('api/userupdate', {
                    id_user: this.user.id_user,
                    email: this.user.email,
                    username: this.user.username,
                    namauser: this.user.namauser,
                    newpassword: this.user.newpassword,
                    hak_akses: this.user.hak_akses,
                    no_hp: this.user.no_hp,
                    kode_referral: this.user.kode_referral,
                    birthday: this.user.birthday,
                    gender: this.user.gender,
                    address: this.user.address,
                    medsos: this.user.medsos
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

    
        hapus: function () {
            axios.post('api/userdel', {
                    id_user: this.user.id_user
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#delMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getPaketAktif: function (ref) {
            axios.get('api/paketsaya/'+ref.id_user)
                .then(res => {
                    this.clearTbl("tblPaketAktif");
                    this.lstpaketaktif = res.data.data;
                    this.initDt("tblPaketAktif");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        getRiwayatPembelian: function (ref) {
            axios.get('api/transaksi/'+ref.id_user)
                .then(res => {
                    this.clearTbl("tblRiwayat");
                    this.lsttransaksi = res.data.data;
                    this.initDt("tblRiwayat");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        goToInvoice: function (ref) {
            
            $("#addMdl").modal('hide');
			localStorage.setItem("idPaket",   ref.id_sales); 
	        if(parseInt(ref.price) >0)
                this.$router.push({name:'admin-paket-belajar-invoice'});//, params: {id: res.data.data}}); 
            else
                this.$router.push({name:'admin-paket-belajar-invoice-gratis'});//, params: {id: res.data.data}}); 
                
        },
 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/User/index.vue